const translations = {
    "sv-SE": {
        dashboard_info: "se dina tjänster",
        dashboard: "All Binary Dashboard",
        email: "epost",
        hamta99_info: "mobilapplikation för samåkning",
        bulletin_vl_info: "kommunicera ut omledning för era resenärer",
        iwa_hlt_info: "helhetsbild över kollektivtrafik genom att kombinera och visualisera data",
        iwa_info: "helhetsbild över kollektivtrafik genom att kombinera och visualisera data",
        iwa_jlt_info: "helhetsbild över kollektivtrafik genom att kombinera och visualisera data",
        iwa_test_info: "iwa för testanvändning",
        iwa_vl_info: "helhetsbild över kollektivtrafik genom att kombinera och visualisera data",
        loading: "laddar",
        org: "organisation",
        sign_out: "logga ut",
        sso_admin_info: "hantera användare",
        username: "användarnamn",
        your_services: "dina tjänster",

        error: "Fel",
        err_fetching_resources: "Fel uppstod vid hämtning av resurser.",
        bugreport_sent: "Felrapport har skickats.",
        click_to_reload: "Klicka för att ladda om.",

        sending: "skickar",
        sending_error_report: "skickar felrapport",
        sent: "skickat",
        error_report_sent: "felrapport har skickats",
        failed: "misslyckande",
        error_report_failed: "felrapport kunde inte skickas",
        please_contact_us: "vänligen kontakta All Binarys support direkt om det händer igen",
        error_has_occured: "fel har uppstått",
        go_to_start: "gå till första sidan"
    },
    "en-US": {
        dashboard_info: "view your services",
        dashboard: "All Binary Dashboard",
        email: "email",
        hamta99_info: "mobile app for ride sharing",
        iwa_hlt_info: "analysis and visualization of public transport statistics",
        iwa_info: "analysis and visualization of public transport statistics",
        iwa_jlt_info: "analysis and visualization of public transport statistics",
        iwa_test_info: "IWA for testing",
        iwa_vl_info: "analysis and visualization of public transport statistics",
        loading: "loading",
        org: "organization",
        sign_out: "log ut",
        sso_admin_info: "user administration tool",
        username: "username",
        your_services: "your services",

        error: "Error",
        err_fetching_resources: "error when fetching resources.",
        bugreport_sent: "bugreport has been sent.",
        click_to_reload: "click to reload.",

        sending: "sending",
        sending_error_report: "sending error report",
        sent: "sent",
        error_report_sent: "error report has been sent",
        failed: "failed",
        error_report_failed: "failed to send error report",
        please_contact_us: "please contact All Binarys support directly if it happens again",
        error_has_occured: "error has occured",
        go_to_start: "go to start"
    }
};

export default translations;



// WEBPACK FOOTER //
// ./src/translations.js